import React, { useState } from 'react';
import { RiCloseFill } from 'react-icons/ri';
import TagInputs from '../layouts/TagInputs';
import { put } from '../../utility/fetch';
import notification from '../../utility/notification';
import { numberWithCommas } from '../../utility/general';
import Spinner from '../UI/Spinner';

const PayReferralLabRequest = ({ isApproval, getProcedures, patientData, closeModal }) => {
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null);
    const [discountModalOpen, setDiscountModalOpen] = useState(false);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [fade, setFade] = useState("fade-in");

    const isMobile = window.innerWidth < 768;

    const openConfirmDialog = (action) => {
        setConfirmAction(action);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setConfirmAction(null);
    };

    const handleConfirmApproveOrDecline = async () => {
        closeConfirmDialog();
        await performApproveOrDecline(confirmAction === 'approve');
    };

    // REFERRAL: /referredpatient/{referralId}/approve-queued-in-lab-services
    const performApproveOrDecline = async (approve = true) => {
        if (!patientData || !patientData.testRequests?.length) {
            notification({ message: 'No queued services to update', type: 'error' });
            return;
        }

        const referralId = patientData?.id;
        const payloadApprove = {
            approveTestRequests: patientData.testRequests.map((r) => ({
                testRequestId: r.id,
                isApproved: approve,
                discount: discountAmount
            }))
        };

        setLoading(true);
        try {
            const res = await put(`/referredpatient/${referralId}/approve-queued-in-lab-services`, payloadApprove);
            if (res?.statusCode === 200 || res?.status === 200) {
                notification({ message: res?.data?.message || 'Operation successful', type: 'success' });
                setDiscountAmount(0);
                getProcedures(1);
                closeModal();
            } else {
                console.error('Approve/decline failed', res);
                notification({ message: 'Failed to update approvals', type: 'error' });
            }
        } catch (err) {
            console.error(err);
            notification({ message: 'Failed to update approvals', type: 'error' });
        } finally {
            setDiscountAmount(0);
            setLoading(false);
        }
    };

    const openDiscountModal = () => {
        setDiscountModalOpen(true);
    };

    const closeDiscountModal = () => {
        setDiscountModalOpen(false);
    };

    const handleApplyDiscount = async () => {
        closeDiscountModal();
        await performApproveOrDecline(true);
    };

    return (
        <>
            <div className="modal">
                <RiCloseFill className='close-btn pointer' onClick={closeModal} />
                <div className={`modal-contents flex flex-direction-v flex-v-center ${fade}`} style={isMobile ? { width: '95%' } : {}}>
                    <div className="w-100">
                        <div>
                            <h1>Approve Referral Lab Request</h1>
                            <div className='m-t-20'>
                                <h2>Test Requests</h2>
                                <div className="tabs bold-text"></div>
                                <div className="m-l-40 col-10 cards no-border p-10" style={isMobile ? { marginLeft: 0, width: '100%', padding: '10px 0' } : {}}>
                                    <div className='flex wrap'>
                                        {
                                            patientData?.testRequests?.map((test, index) => (
                                                <div key={test?.id} className={`flex m-t-20`}>
                                                    <div className="m-r-10">{test?.referredInternalLabService?.name}</div>
                                                </div>
                                            ))
                                        }
                                    </div>

                                    <div className="p-10">
                                        <TagInputs
                                            label="Amount"
                                            value={numberWithCommas(
                                                patientData?.testRequests?.reduce((acc, curr) =>
                                                    acc + (curr?.referredInternalLabService?.cost || 0), 0
                                                )
                                            )}
                                            readOnly
                                        />

                                        {isApproval && (
                                            <div style={{ display: 'flex', gap: 8, marginTop: 12, flexDirection: 'column'  }}>
                                                <div style={{ display: 'flex', gap: 8, flexDirection: isMobile ? 'column' : 'row' }}>
                                                    <button
                                                        disabled={loading}
                                                        onClick={() => openConfirmDialog('approve')}
                                                        className="submit-btn"
                                                        style={{ backgroundColor: '#28a745', marginRight: 8, flex: 1 }}
                                                    >
                                                        {loading ? 'Processing...' : 'Approve All'}
                                                    </button>

                                                    <button
                                                        disabled={loading}
                                                        onClick={() => openConfirmDialog('decline')}
                                                        className="submit-btn"
                                                        style={{ backgroundColor: '#d32f2f', flex: 1 }}
                                                    >
                                                        {loading ? 'Processing...' : 'Decline All'}
                                                    </button>
                                                </div>
                                                <button
                                                    disabled={loading}
                                                    onClick={openDiscountModal}
                                                    className="submit-btn"
                                                    style={{ backgroundColor: '#ff9800' }}
                                                >
                                                    {loading ? 'Processing...' : 'Give Discount'}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirmation Modal */}
            {confirmDialogOpen && (
                <div className="modal">
                    <div className={`modal-contents flex flex-direction-v flex-v-center ${fade}`} style={{ maxWidth: '400px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <h2 style={{ marginTop: 0 }}>Confirm Action</h2>
                            <p style={{ color: '#666', marginBottom: 24 }}>
                                Are you sure you want to <strong>{confirmAction === 'approve' ? 'approve' : 'decline'}</strong> all queued lab services?
                            </p>
                            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
                                <button
                                    onClick={closeConfirmDialog}
                                    className="submit-btn"
                                    style={{ backgroundColor: '#999', flex: 1 }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleConfirmApproveOrDecline}
                                    disabled={loading}
                                    className="submit-btn"
                                    style={{
                                        backgroundColor: confirmAction === 'approve' ? '#28a745' : '#d32f2f',
                                        flex: 1
                                    }}
                                >
                                    {loading ? 'Processing...' : (confirmAction === 'approve' ? 'Approve' : 'Decline')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Discount Modal */}
            {discountModalOpen && (
                <div className="modal">
                    <div className={`modal-contents flex flex-direction-v flex-v-center ${fade}`} style={{ maxWidth: '400px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <h2 style={{ marginTop: 0 }}>Give Discount</h2>
                            <p style={{ color: '#666', marginBottom: 16 }}>
                                Enter the discount amount
                            </p>
                            <div style={{ marginBottom: 24 }}>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={discountAmount}
                                    onChange={(e) => setDiscountAmount(parseFloat(e.target.value) || 0)}
                                    placeholder="Discount amount"
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '4px',
                                        border: '1px solid #ddd',
                                        fontSize: '16px'
                                    }}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
                                <button
                                    onClick={closeDiscountModal}
                                    className="submit-btn"
                                    style={{ backgroundColor: '#999', flex: 1 }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleApplyDiscount}
                                    disabled={loading}
                                    className="submit-btn"
                                    style={{
                                        backgroundColor: '#ff9800',
                                        flex: 1
                                    }}
                                >
                                    {loading ? 'Processing...' : 'Apply Discount'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PayReferralLabRequest;